import { BudgetRangeServer } from "model/campaigns/budgets";
import { Integer } from "model/modelTypes";

export type CampaignPageNotificationType = {
  id: string;
  campaignId: string;
  campaignName: string;
  lineitemId?: string;
  lineitemName?: string;
  reason: NotificationReason;
  rejectedInstalls?: Integer;
  budget?: BudgetRangeServer;
};

export enum NotificationReason {
  lineitemEndsIn3days = "lineitemEndsIn3days",
  campaignEndsIn3days = "campaignEndsIn3days",
  campaignSpendOver90 = "campaignSpendOver90",
  lineitemSpendOver90 = "lineitemSpendOver90",
  campaignRejectedInstallsHigh = "campaignRejectedInstallsHigh",
  campaignBudgetSpendOver90 = "campaignBudgetSpendOver90",
}
